import {FtpFileConfiguration} from './FtpFileConfiguration';

export class PutFtpFileConfiguration extends FtpFileConfiguration {
exitStatusOnMovedFile: boolean | null;
exitStatusOnNoFile: boolean | null;
putWitnessFile: boolean | null;
}

